<script>
import Layout from '../../../layouts/auth'
import appConfig from '@/app.config'
import { mapGetters } from 'vuex'
import { Helper } from '@/mixin/helper'

export default {
  page: {
    title: 'Lupa Kata Sandi',
    meta: [
      {
        name: 'description',
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
  },
  mixins: [Helper],
  computed: {
    ...mapGetters({
      getAsset: 'asset/getAsset',
    }),
  },
  created() {
    setTimeout(() => {
      localStorage.removeItem('emailOTP')
      localStorage.removeItem('otpCode')
      const storedDomain = localStorage.getItem("domainName");

      const domainName = storedDomain && storedDomain !== 'undefined'
        ? `https://${storedDomain}/login`
        : `${process.env.BASE_URL}login`;

      location.href = domainName;
    }, 3000)
  },
  data() {
    return {
      email: '',
    }
  },
  mounted() {
    this.adjustImageSize()
  },
  methods: {
    adjustImageSize() {
      this.resizeImage(this.$refs.imgPrimaryLogo, 45, 150)
      this.resizeImage(this.$refs.imgCopyrightLogo, 15, 50)
    },
  },
}
</script>
<template>
  <Layout>
    <div class="mc-auth__form">
      <h1 class="mc-auth__logo pt-5">
        <router-link to="/">
          <img :src="getAsset('primaryLogo', 'login')" alt ref="imgPrimaryLogo" />
        </router-link>
      </h1>
      <div class="mc-auth__form-wrapper mc-auth__form-wrapper--forgot">
        <div class="mc-upload">
          <div class="mc-upload-result mc-upload-result--success">
            <figure>
              <img src="@/assets/images/success-icon.png" alt />
            </figure>
            <h4 class="mc-upload-result__label">{{ $t('forgotPassword.text.successReset') }}</h4>
          </div>
        </div>
      </div>
      <div class="mc-auth__copyright">
        <span
          :hidden="
            getAsset('copyrightLogo', 'general') == null ||
            getAsset('copyrightLogo', 'general') == ''
          "
          >{{ $t('login.text.presented') }}
          <img :src="getAsset('copyrightLogo', 'general')" alt class="ms-2" ref="imgCopyrightLogo"
        /></span>
      </div>
    </div>
  </Layout>
</template>
